import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './styles.scss';
import CustomRoutes from './routes';
import AgendaSocket from './components/shared/AgendaSocket';
import PushNotificationModal from './components/shared/PushNotificationModal';
import NotificationDetailModal from './components/shared/NotificationDetailModal';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
          <div className="App">
            <div className="App-header">
              {/* Una sola conexión de avisos por sesión, para toda la app. */}
              <AgendaSocket />
              <BrowserRouter>
                {/* Push tipo notificación: cola de avisos en vivo (portal). */}
                <PushNotificationModal />
                {/* Detalle de una notificación (anuncios) — portal. */}
                <NotificationDetailModal />
                <CustomRoutes />
              </BrowserRouter>
            </div>
          </div>
        </Worker>
      </PersistGate>
    </Provider>
  );
}

export default App;
